import { createFileRoute, Outlet } from '@tanstack/react-router';
import { t } from '@lingui/core/macro';

export const Route = createFileRoute('/_authenticated/_supply-point-scope/devices')({
  component: Outlet,
  loader: () => ({
    breadcrumb: t`Devices`,
  }),
});
